function UseEnv() {
  return JSON.parse(process.env.VUE_APP_USE_ENV);
}

export const PublicPath = UseEnv() ? '${VUE_APP_PUBLIC_PATH}' : process.env.VUE_APP_PUBLIC_PATH;
export const BaseApiUrl = UseEnv() ? '${VUE_APP_API_BASE_URL}' : process.env.VUE_APP_API_BASE_URL;
export const TeCommonApiUrl = UseEnv() ? '${VUE_APP_API_TECOMMON_URL}' : process.env.VUE_APP_API_TECOMMON_URL;
export const SsoApiUrl = UseEnv() ? '${VUE_APP_API_SSO_URL}' : process.env.VUE_APP_API_SSO_URL;
